//文字コードはutf-8

/* IRニュース
========================================================*/
export function initIrNews() {
    var $ = jQuery;
    var moment = window.moment;

    if (!window.IR_CONFIG) return;

    var COMPANY_CODE = window.IR_CONFIG.COMPANY_CODE;
    var API_URL = window.IR_CONFIG.API_URL;
    var ALL_LABEL = '全て';
    var PER_PAGE = 20;

    var groupCode = window.IR_CONFIG.groupCode;
    var groupLabel = window.IR_CONFIG.groupLabel;

    var categoryOrder = [ALL_LABEL, '適時開示', '決算短信', '法定開示', 'IR資料', 'お知らせ'];
    var activeLabel = ALL_LABEL;
    var allData = null;
    var currentPage = 1;

    function unique(items) {
        var result = [];
        var seen = {};

        $.each(items, function (_, item) {
            if (seen[item]) return;
            seen[item] = true;
            result.push(item);
        });

        return result;
    }

    function makeData(items) {
        items = items || [];
        return {
            items: items,
            length: items.length
        };
    }

    function checkData(data) {
        if (data && $.isArray(data.items)) {
            return makeData(data.items.slice());
        }
        return makeData([]);
    }

    function decodeEntities(value) {
        if (value == null) return '';
        return $('<div/>').html(String(value)).text();
    }

    function escapeHtml(value) {
        return decodeEntities(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function formatDate(value, format) {
        var date = moment(new Date(value));
        if (!date.isValid()) return '';
        return date.format(format);
    }

    function formatFileSize(size) {
        var units = ['Byte', 'KB', 'MB', 'GB'];
        var unitIndex = 0;
        var parsedSize = parseInt(size, 10);

        if (!parsedSize) return '';

        while (parsedSize >= 1024 && unitIndex < units.length - 1) {
            parsedSize = parsedSize / 1024;
            unitIndex++;
        }

        parsedSize = unitIndex >= 2 ? Math.round(parsedSize * 10) / 10 : Math.round(parsedSize);
        return parsedSize + units[unitIndex];
    }

    function formatFileInfo(file) {
        if (!file) return '';

        var size = formatFileSize(file.size);
        var page = parseInt(file.page, 10);
        var pageText = page ? '/' + page + 'P' : '';

        return size ? '（' + size + pageText + '）' : '';
    }

    function findCategory(code) {
        var parsedCode = parseInt(code, 10);
        var category;

        for (category in groupLabel) {
            if ($.inArray(parsedCode, groupLabel[category].doctype) !== -1) {
                return {
                    name: category,
                    id: groupLabel[category].id
                };
            }
        }

        return {
            name: 'その他',
            id: 0
        };
    }

    function findFile(files, fileType) {
        var result = null;

        if (!$.isArray(files)) return null;

        $.each(files, function (_, file) {
            if (file.type === fileType) {
                result = file;
                return false;
            }
        });

        return result || files[0] || null;
    }

    function isPdfUrl(url) {
        return /\.pdf(?:[?#].*)?$/i.test(url);
    }

    function isExternalUrl(url) {
        var parsedUrl;

        try {
            parsedUrl = new URL(url, window.location.href);
        } catch (error) {
            return false;
        }

        return parsedUrl.hostname !== window.location.hostname;
    }

    function isNewDate(value) {
        var date = moment(new Date(value));
        if (!date.isValid()) return false;
        return moment().diff(date, 'days') < 30;
    }

    function getAllDoctypes() {
        var doctypes = [];

        $.each(categoryOrder, function (_, label) {
            if (label === ALL_LABEL) return;
            doctypes = doctypes.concat(groupLabel[label].doctype);
        });

        return unique(doctypes).join(',');
    }

    function filterData(data, label) {
        var config = groupLabel[label];
        var items = [];

        data = checkData(data);

        if (!config) return data;

        $.each(data.items, function (_, item) {
            if ($.inArray(parseInt(item.disclosureCode, 10), config.doctype) !== -1) {
                items.push(item);
            }
        });

        return makeData(items);
    }

    function sortData(data) {
        data = checkData(data);
        data.items.sort(function (a, b) {
            return new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime();
        });
        data.length = data.items.length;
        return data;
    }

    function getCurrentData() {
        if (activeLabel === ALL_LABEL) {
            return checkData(allData);
        }
        return filterData(allData, activeLabel);
    }

    function getTotalPages(data) {
        return Math.max(1, Math.ceil(data.length / PER_PAGE));
    }

    function getPageData(data, page) {
        var start = (page - 1) * PER_PAGE;
        return makeData(data.items.slice(start, start + PER_PAGE));
    }

    function getCategoryList() {
        return {
            items: $.map(categoryOrder, function (label) {
                return {
                    label: label,
                    active: label === activeLabel,
                    normalCase: label === 'IR資料'
                };
            })
        };
    }

    function renderList(data) {
        $('#list').html($('#tpl-list').render(checkData(data)));
    }

    function renderError() {
        $('#list').html('<p class="modIRNewsMessage modIRNewsMessage--error">IRニュースの取得に失敗しました。時間をおいて再度お試しください。</p>');
        $('#pagination').html('');
    }

    function renderPagination(totalPages) {
        var html = '';
        var startPage, endPage, i;

        if (totalPages <= 1) {
            $('#pagination').html('');
            return;
        }

        startPage = Math.max(1, currentPage - 2);
        endPage = Math.min(totalPages, startPage + 4);
        startPage = Math.max(1, endPage - 4);

        if (currentPage > 1) {
            html += '<a href="#" class="modPagination__arrow modPagination__arrow--prev" data-page="' + (currentPage - 1) + '" aria-label="前のページ">PREV<span class="modRightChevron modRightChevron--reverse" aria-hidden="true"></span></a>';
        }

        html += '<ul class="modPagination__pages">';
        for (i = startPage; i <= endPage; i++) {
            html += '<li class="modPagination__pages__item';
            if (i === currentPage) {
                html += ' modPagination__pages__item--current';
            }
            html += '"><a href="#" data-page="' + i + '">' + i + '</a></li>';
        }
        html += '</ul>';

        if (currentPage < totalPages) {
            html += '<a href="#" class="modPagination__arrow" data-page="' + (currentPage + 1) + '" aria-label="次のページ">NEXT<span class="modRightChevron" aria-hidden="true"></span></a>';
        }

        $('#pagination').html(html);
    }

    function switchList() {
        var data = getCurrentData();
        var totalPages = getTotalPages(data);

        if (currentPage > totalPages) {
            currentPage = totalPages;
        }

        renderList(getPageData(data, currentPage));
        renderPagination(totalPages);
    }

    function updateActiveCategory($item) {
        $('#filterMenu .modSection__sideMenu__item').removeClass('modSection__sideMenu__item--active');
        $item.addClass('modSection__sideMenu__item--active');
        $('.modSection__content__title').text('「' + (activeLabel === ALL_LABEL ? '全て' : activeLabel) + '」の記事一覧');
    }

    function registerTemplateTools() {
        $.views.converters({
            date: function (value) {
                var format = this.tagCtx.props.format || 'YYYY年M月D日';
                return formatDate(value, format);
            },
            label: function (code) {
                var category = findCategory(code);
                return this.tagCtx.props.get === 'id' ? category.id : category.name;
            },
            link: function (files) {
                var props = this.tagCtx.props;
                var file = findFile(files, props.fileType);
                var title = props.text || '';
                var category = findCategory(props.disclosureCode);
                var dateTime = formatDate(props.publishDate, 'YYYY-MM-DD');
                var dateText = formatDate(props.publishDate, 'YYYY.MM.DD');
                var fileInfo = formatFileInfo(file);
                var url = file && file.url ? encodeURI(file.url) : '';
                var tagName = url ? 'a' : 'span';
                var classes = ['modListNews__item__link'];
                var attrs = '';
                var newHtml = isNewDate(props.publishDate) ? '<span class="new">NEW</span>' : '';

                if (url) {
                    attrs += ' href="' + escapeHtml(url) + '"';
                    if (isPdfUrl(url)) {
                        classes.push('pdf');
                        classes.push('modListNews__item__link--pdf');
                    } else if (isExternalUrl(url)) {
                        classes.push('blank');
                        classes.push('modListNews__item__link--external');
                    }
                    if (isPdfUrl(url) || isExternalUrl(url)) {
                        attrs += ' target="_blank" rel="noopener noreferrer"';
                    }
                } else {
                    attrs += ' aria-disabled="true"';
                    classes.push('irNewsLink--disabled');
                }

                attrs += ' class="' + classes.join(' ') + '"';

                return '<' + tagName + attrs + '>' +
                    '<div class="heading"><h3>' + escapeHtml(title) +
                    (fileInfo ? '<span class="unit">' + escapeHtml(fileInfo) + '</span>' : '') +
                    '</h3></div>' +
                    '<time class="date" datetime="' + escapeHtml(dateTime) + '">' + escapeHtml(dateText) + '</time>' +
                    '<span class="tag irCat irCat_' + escapeHtml(category.id) + '">' + escapeHtml(category.name) + '</span>' +
                    newHtml +
                    '</' + tagName + '>';
            }
        });

        $.views.helpers({
            isNew: isNewDate
        });
    }

    if (!$('#filterMenu').length || !$('#tpl-list').length) return;

    if (!$.views || !moment) {
        renderError();
        return;
    }

    registerTemplateTools();

    $('#filterMenu').html($('#tpl-filterMenu').render(getCategoryList()));

    $('#filterMenu').on('click', 'a', function (event) {
        var $item = $(this).closest('.modSection__sideMenu__item');

        event.preventDefault();
        activeLabel = $item.data('label') || ALL_LABEL;
        currentPage = 1;
        updateActiveCategory($item);
        switchList();
    });

    $('#pagination').on('click', 'a', function (event) {
        var page = $(this).data('page');

        event.preventDefault();
        if (page && page !== currentPage) {
            currentPage = page;
            switchList();
        }
    });

    $.ajax({
        url: API_URL,
        type: 'GET',
        cache: false,
        dataType: 'jsonp',
        data: {
            company: COMPANY_CODE,
            output: 'json',
            len: 10000,
            doctype: getAllDoctypes()
        }
    }).done(function (response) {
        allData = sortData(response);
        switchList();
    }).fail(renderError);
}
